import React from 'react';
import LazyTable from 'app/component/lazy-table';
import { formatBigDecimalIntoString } from 'app/shared/util/number-utils';
import { Checkbox } from 'primereact/checkbox';
import { Card } from 'primereact/card';
import { ColorPicker } from 'primereact/colorpicker';

const BonusDeductionTable: React.FC = () => {
  const formatName = v => {
    if (v?.firstName) {
      if (v.lastName) {
        return v.firstName + ' ' + v.lastName;
      }

      return v.firstName;
    }

    return v.name;
  };

  const showToClientCheckbox = zaplatene => {
    return <Checkbox disabled={true} style={{ marginLeft: '1rem' }} checked={zaplatene as boolean} />;
  };

  const rowClassName = data => {
    if (data?.applied && data?.forProvisions) {
      return 'row-color-latest';
    }

    return ``;
  };

  const legend = () => {
    return (
      <Card className="p-4">
        <div className="flex flex-wrap gap-4">
          <div key={1} className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full" style={{ backgroundColor: 'blue' }}></div>
            <span>ahadf</span>
          </div>
        </div>
      </Card>
    );
  };

  return LazyTable({
    initialSortField: 'id',
    initialSortDirection: 'desc',
    createUrl: '/create-bonus-deduction',
    editActionAllowed: true,
    labelForCreateEntity: 'Vytvoriť nový bonus/zrážku',
    serverUrl: '/api/bonus-deductions',
    globalFilterFields: ['number', 'documentName'],
    searchAllowed: false,
    deleteActionAllowed: true,
    rowClassName,
    columns: [
      { field: 'id', header: 'ID', sortable: true },
      { field: 'description', header: 'Opis', sortable: true },
      { field: 'agent', header: 'Poradca', formatter: formatName },
      { field: 'value', header: 'Suma', sortable: true, formatter: v => formatBigDecimalIntoString(v) + ' EUR' },
      { field: 'forStornofond', header: 'Pre stornofond', sortable: true, formatter: showToClientCheckbox },
      { field: 'forProvisions', header: 'Pre provízie', sortable: true, formatter: showToClientCheckbox },
      { field: 'nrOfProvisionZostava', header: 'Provízne zostavy', sortable: false },
      { field: 'applied', header: 'Už aplikované', sortable: true, formatter: showToClientCheckbox },
    ],
    additionalHeaderButtons: (
      <span>
        <ColorPicker value="#2196F3" disabled={true} />
        Bonus/zrážka aplikovaný/á na reporte alebo províznom liste
      </span>
    ),
  });
};

export default BonusDeductionTable;
